import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=c21ec4b2&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UploadImg.vue?vue&type=style&index=1&id=c21ec4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21ec4b2",
  null
  
)

export default component.exports